import * as React from "react"
const Adventure = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.383}
      d="M4.748 26.473h23.825l-9.16-19.341a3.045 3.045 0 0 0-5.504 0L4.748 26.473Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.383}
      d="m10.704 14.56 2.647 3.309 3.31-3.31 2.647 3.972 3.309-2.647"
    />
  </svg>
)
export default Adventure